import * as React from 'react';

import {getRemoveConfirmationTextFromChannel} from 'nutshell-core/channels/helpers';

import {ChannelIconWithName} from '../../channels/channel-icon-with-name';
import type {ChannelType} from '../../channels/types';

import {SectionItem} from '../section-item';

import {SourcesSectionContent} from './sources-section-content';
import type {Source} from './types';

type Props = {
    channel: ChannelType | null | undefined;
    sources: Source[];
    sourceOptions: Source[];
    onRemoveChannel: (channel: number) => Promise<any>;
    onRemoveSource: (sourceId: string) => any;
    onAddSource: (sourceId: string) => any;
    canAccessSetup: boolean;
};

export function SourcesSection(props: Props) {
    const {
        channel,
        sources,
        sourceOptions,
        onAddSource,
        onRemoveSource,
        onRemoveChannel,
        canAccessSetup,
    } = props;

    return (
        <SectionItem
            sectionEntity='sources'
            itemHeaderComponent={<ChannelIconWithName channel={channel} />}
            content={
                <SourcesSectionContent
                    channel={channel}
                    sources={sources}
                    sourceOptions={sourceOptions}
                    onAddSource={onAddSource}
                    onRemoveSource={onRemoveSource}
                    canAccessSetup={canAccessSetup}
                />
            }
            removeConfirmationText={getRemoveConfirmationTextFromChannel(channel)}
            onClickRemove={onRemoveChannel}
        />
    );
}
